'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461 from "./presto.types$-Directive-Description$$anon$61.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462 from "./presto.types$-Directive-Description$$anon$62.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveDescription$() {
  this.c67 = null;
  this.c68 = false;
  this.c65 = null;
  this.c66 = false;
  this.c6b = null;
  this.c6c = false;
  this.c69 = null;
  this.c6a = false;
  this.c6d = null;
  this.c6e = false;
}
export { $c_Lpresto_types$DirectiveDescription$ as $c_Lpresto_types$DirectiveDescription$ };
$p = $c_Lpresto_types$DirectiveDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveDescription$;
/** @constructor */
function $h_Lpresto_types$DirectiveDescription$() {
}
export { $h_Lpresto_types$DirectiveDescription$ as $h_Lpresto_types$DirectiveDescription$ };
$h_Lpresto_types$DirectiveDescription$.prototype = $p;
$p.cIY = (function() {
  if ((!this.c68)) {
    this.c67 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c68 = true;
  }
  return this.c67;
});
$p.vf = (function() {
  if ((!this.c66)) {
    this.c65 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c66 = true;
  }
  return this.c65;
});
$p.cJI = (function() {
  if ((!this.c6c)) {
    this.c6b = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6c = true;
  }
  return this.c6b;
});
$p.cJv = (function() {
  if ((!this.c6a)) {
    this.c69 = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461.$c_Lpresto_types$DirectiveDescription$$anon$61(this);
    this.c6a = true;
  }
  return this.c69;
});
$p.cJZ = (function() {
  if ((!this.c6e)) {
    this.c6d = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462.$c_Lpresto_types$DirectiveDescription$$anon$62(this);
    this.c6e = true;
  }
  return this.c6d;
});
var $d_Lpresto_types$DirectiveDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveDescription$, "presto.types$DirectiveDescription$", ({
  ZB: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveDescription$ as $d_Lpresto_types$DirectiveDescription$ };
var $n_Lpresto_types$DirectiveDescription$;
function $m_Lpresto_types$DirectiveDescription$() {
  if ((!$n_Lpresto_types$DirectiveDescription$)) {
    $n_Lpresto_types$DirectiveDescription$ = new $c_Lpresto_types$DirectiveDescription$();
  }
  return $n_Lpresto_types$DirectiveDescription$;
}
export { $m_Lpresto_types$DirectiveDescription$ as $m_Lpresto_types$DirectiveDescription$ };
//# sourceMappingURL=presto.types$-Directive-Description$.js.map
